import type { RouteDef } from '../router';
import { articlesPending, listBlogIndex, hasBlogPost } from '../data/articles';
import { t, getLocale } from '../i18n';
import type { TranslationKey } from '../i18n/types';
import { blogIndexHtml } from '@roamzy/shared';

const blog: RouteDef = {
  path: '/blog',
  whenReady: articlesPending,
  routeType: 'blog',
  navKey: 'blog',
  metaTitle: 'Journal — Travel eSIM Guides & Comparisons | Roamzy',
  metaDesc: 'Field notes, comparisons, and guides on travel eSIMs, roaming, and mobile data abroad.',
  // The server sends this page (backend listing-body.ts, the same renderer);
  // the router keeps it on first paint. An in-app navigation renders the
  // same markup from the same data (shared/blog-index.ts); until 2026-10-05
  // it drew a hand-kept list with English dates and links instead.
  prerenderMarker: '.blog-index-route',
  hydrate: () => '',
  render() {
    return blogIndexHtml({
      locale: getLocale(),
      t: (key, vars) => t(key as TranslationKey, vars),
      posts: listBlogIndex(),
      hasBlogTranslation: hasBlogPost,
    });
  },
};

export default blog;
